import {GET_USERS_FAQ, USERS_FAQ_ERROR} from 'app/types'

const initialState = {
    usersFAQ:[],
    loading:true
}

export default function userFAQReducer (state = initialState, action) {
    switch(action.type){

        case GET_USERS_FAQ:
            return {
                ...state,
                usersFAQ:action.payload,
                loading:false
            }
        case USERS_FAQ_ERROR:
            return{
                loading: false, 
                error: action.payload 
            }
        default: return state
    }
}

 